import { render, staticRenderFns } from "./ScreenshareSourcesPickerModal.vue?vue&type=template&id=5d516ac1&scoped=true"
import script from "./ScreenshareSourcesPickerModal.vue?vue&type=script&lang=js"
export * from "./ScreenshareSourcesPickerModal.vue?vue&type=script&lang=js"
import style0 from "./ScreenshareSourcesPickerModal.vue?vue&type=style&index=0&id=5d516ac1&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d516ac1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2718431902/src/v-meetings/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d516ac1')) {
      api.createRecord('5d516ac1', component.options)
    } else {
      api.reload('5d516ac1', component.options)
    }
    module.hot.accept("./ScreenshareSourcesPickerModal.vue?vue&type=template&id=5d516ac1&scoped=true", function () {
      api.rerender('5d516ac1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/modals/ScreenshareSourcesPickerModal.vue"
export default component.exports